import {css} from 'lit'; export default css`*,:after,:before{box-sizing:border-box}:host{display:block}.sds-switcher{display:flex}`;
    